import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'
import { convertDate } from '../Helper'

interface UserDetailListProps {
  value: string
  iconId: string
  label: string
}

export const UserDetailList = ({ item }: any) => {
  const { user, email, createdDate } = item
  const mobilenumber = `+${user?.mobile?.countryCode} ${user?.mobile?.mobileNumber}`
  const dataMap = [
    {
      value: mobilenumber ?? 'N/A',
      iconId: 'MobileIcon',
      label: 'Mobile Number',
    },
    {
      value: email?.length ? email : 'N/A',
      iconId: 'MailIcon',
      label: 'Email',
    },
    {
      value: createdDate?.length ? convertDate(createdDate) : 'N/A',
      iconId: 'AddUserIcon',
      label: 'Added on',
    },
  ]
  const renderMap = dataMap?.map((ele: UserDetailListProps, index: number) => {
    if (ele.value === 'N/A') {
      return null
    }
    return (
      <Box flexDirection={'row'} alignItems="center" key={index} pv={8}>
        <SvgImage imageName={ele.iconId} width={24} height={24} color={Colors.SECONDARY} />
        <Spacer size={16} direction={'horizontal'} />
        <Box>
          <Text
            fontFamily={'JioType-Medium'}
            fontSize={12}
            color={Colors.PRIMARY_GREY}
            lineHeight={18}
            letterSpacing={-0.06}>
            {ele.label}
          </Text>
          <Text
            fontFamily={'JioType-Medium'}
            fontSize={14}
            color={Colors.BLACK_14 as ColorOptions}
            lineHeight={20}
            letterSpacing={-0.07}>
            {ele.value}
          </Text>
        </Box>
      </Box>
    )
  })

  return <>{renderMap}</>
}
